import { useGateValue } from "@statsig/react-bindings";

import { TASKS_V2_GATE } from "@/types/userTasks.ts";

/** The per-thread tasks' gate. */
export const TASKS_GATE = "tasks";

/**
 * Which task views the account has: the per-thread tasks (`tasks`), the user's
 * list (`tasks-v2`), or either. Under either, there is a Tasks tab; the list's
 * gate decides which data it shows.
 */
export function useTaskGates(): { threadTasks: boolean; list: boolean; any: boolean } {
  const threadTasks = useGateValue(TASKS_GATE);
  const list = useGateValue(TASKS_V2_GATE);
  return { threadTasks, list, any: threadTasks || list };
}
